import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { TankAbstract } from 'src/app/models/department-reports.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { shareReplay } from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-lot-consolidated-report',
  templateUrl: './lot-consolidated-report.component.html',
  styleUrls: ['./lot-consolidated-report.component.scss']
})
export class LotConsolidatedReportComponent implements OnInit {

  tankAbstract: any[];
  tankApp: any;
  tankCoverageArea: any;
  tankVerifiedApp: any;
  tankRpApp: any;
  tankRejectedApp: any;
  tankVerifiedCoverageApp: any;
  grandTankApp: number;
  grandTankCoverageArea: number;
  grandTankVerifiedApp: number;
  grandTankRpApp: number;
  grandTankRejectedApp: number;
  grandTankVerifiedCoverageApp: number;
  arrayIndex: number;
  tempTankAbstract: any;
  appVerificationItems: MenuItem[];
  appVerificationModel: TankAbstract[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  drilldownDetails: any;
  public userID: any;
  value: any;
  displayMaximizable_all: any
  displayMaximizable_verified: any
  displayMaximizable_rp: any
  displayMaximizable_rejected: any
  routePath: any;
  subjectSub: any;
  selectedYear: any;
  public subscriptions: any = [];
  public loading: boolean = false;
  public applicationForm: FormGroup;
  public isSubmitted: boolean = false;
  vendorId: any;

  public tableHeight: any = '50px';
  
  constructor(private reportsService: ReportsService
    , private messageService: MessageService
    , private dashboard: DashboardService
    , private router: Router
    , private activityRecordService: ActivityRecordService
    , private loader: AppLoaderService
    , private service: BaseService
    , private fb: FormBuilder
    , private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if (sessionStorage.getItem('financialYear')) {
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encData);

    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    const officeCode = tokenInfo['officeCode'] ? tokenInfo['officeCode'] : null;
    
    this.vendorId = officeCode;

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        let router = this.router.url
        // this.routePath=router.split('/')

        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear = res

        // this.loadData(this.selectedYear)
      }

    );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "LOT_report");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.appVerificationModel, "LOT_report");
      //   }
      // },
    ];
    this.applicationForm = this.fb.group({
      vendorId: ['', Validators.required],
      programId: [''],
    });
    this.loadData()
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe()
    }
  }

  loadData() {
    // this.loader.start();
    this.loading = true;
    let sub = this.reportsService.getLotConsolidatedReport()
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.activityRecordService.activityRecord(this.userID, 'Tank Abstract Report', '', new Date(), 'Success');
          // this.loader.close();
          this.loading = false;
          if (data?.length > 0) {
            this.tableHeight = '400px';
            this.tankAbstract = data;
            this.appVerificationModel = data;
            this.tempTankAbstract = data;
            this.arrayIndex = 0;
            // this.calculateGrandTotal()

          }
          else {
            this.tableHeight = '50px';
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
            this.tankAbstract = [];
            this.appVerificationModel = [];
            this.tempTankAbstract = [];
            this.arrayIndex = 0;
          }
        },
        error: (err) => {
          this.tankAbstract = [];
          this.appVerificationModel = [];
          this.tempTankAbstract = [];
          this.arrayIndex = 0;
          this.tableHeight = '50px';
          this.loading = false;
          // this.activityRecordService.activityRecord(this.userID, 'Tank Abstract Report', '', new Date(), err);

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

        }
      });
    this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {

    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Status": d.Status,
          "Stage": d.Stage,
          "Lot No": d.LotNos,
          "Total No of Lot": d.TotalNoOfLots,
          "Total Records": d.TotalRecords,
          "Total PFMS Amount": d.SumTotalAmt,

          "Success Records": d.TotalSuccessfulRecords,
          "Success Amount": d.AmtSuccessfulRecords,

          "Failed Records": d.TotalFailedRecords,
          "Failed Amount": d.AmtFailedRecords,
        }
      })

      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'Status', header: 'Status' },
      { field: 'Stage', header: 'Stage' },
      { field: 'LotNos', header: 'Lot No' },
      { field: 'TotalNoOfLots', header: 'Total No of Lot' },
      { field: 'TotalRecords', header: 'Total Records' },
      { field: 'SumTotalAmt', header: 'Total PFMS Amount' },

      { field: 'TotalSuccessfulRecords', header: 'Success Records' },
      { field: 'AmtSuccessfulRecords', header: 'Success Amount' },

      { field: 'TotalFailedRecords', header: 'Failed Records' },
      { field: 'AmtFailedRecords', header: 'Failed Amount' },

    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default('l', 'mm', 'a4');
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempTankAbstract = event.filteredValue
    //console.log(event);
    this.arrayIndex = 0;
    // console.log(this.vendorWise);
    this.calculateTotalApp();
  }
  onPage(event: any) {
    this.arrayIndex = event.first;
    this.calculateTotalApp()
    //console.log(event);
  }
  calculateTotalApp() {
    this.tankApp = 0;
    this.tankCoverageArea = 0;
    this.tankVerifiedApp = 0;
    this.tankRpApp = 0;
    this.tankRejectedApp = 0;
    this.tankVerifiedCoverageApp = 0;
    for (let i = this.arrayIndex; this.tempTankAbstract.length > 10 ? i < this.arrayIndex + 10 : i < this.tempTankAbstract.length; i++) {
      //console.log( this.totalApp,"totalAPPPPPPPPP")
      this.tankApp += this.tempTankAbstract[i].Tank_App;
      this.tankCoverageArea += this.tempTankAbstract[i].Tank_Coverage_Area;
      this.tankVerifiedApp += this.tempTankAbstract[i].Tank_Verified_App;
      this.tankRpApp += this.tempTankAbstract[i].Tank_RP_App;
      this.tankRejectedApp += this.tempTankAbstract[i].tank_Rejected_App;
      this.tankVerifiedCoverageApp += this.tempTankAbstract[i].Tank_Verified_Coverage_Area;

    }

  }
  // calculateGrandTotal(){
  //   this.grandTankApp=0;
  //   this.grandTankCoverageArea=0;
  //   this.grandTankVerifiedApp=0;
  //   this.grandTankRpApp=0;
  //   this.grandTankRejectedApp=0;
  //   this.grandTankVerifiedCoverageApp=0;
  //   for(let vendorData of this.tempTankAbstract) {
  //     this.grandTankApp += vendorData.Tank_App;
  //     this.grandTankCoverageArea += vendorData.Tank_Coverage_Area;
  //     this.grandTankVerifiedApp += vendorData.Tank_Verified_App;
  //     this.grandTankRpApp += vendorData.Tank_RP_App;
  //     this.grandTankRejectedApp += vendorData.tank_Rejected_App;
  //     this.grandTankVerifiedCoverageApp += vendorData.Tank_Verified_Coverage_Area;
  // }
  // }
  showMaximizableDialog(district: any, status: any) {

    // if(status=='All'){
    //   this.displayMaximizable_all=true
    // }
    // if(status=='Approved'){
    //   this.displayMaximizable_verified=true
    // }
    // if(status=='Incomplete'){
    //   this.displayMaximizable_rp=true
    // }
    // if(status=='Rejected'){
    //   this.displayMaximizable_rejected=true
    // }
    // this.value=district;
    // this.drilldownDetails={
    //   district:district,
    //   status:status,
    // }

    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")

  }
  get f() {
    return this.applicationForm.controls;
  }
  clearAppNo() {
    this.f.vendorId.setValue(null);
  }
  submitApplication() {
    // console.log(this.f.vendorId.value,"dddddddddddd")
    this.isSubmitted = true;
    this.loadData()

  }

  rowBackgroundColor(row) {
    if (row.Status == 'Pending-MI' || row.Status == 'Pending-Pond') {
      return '#ffb3b3';
      // '#ff8080'
    } else if (row.Status == 'Uploaded-MI' || row.Status == 'Uploaded-Pond') {
      return '#99e699';
      // return '#99e699';
    } else return '#ffb3b3';
  }

  calculateCustomerTotal(name: string) {
    let total = 0;

    if (this.tankAbstract) {
        for (let customer of this.tankAbstract) {
            if (customer.Status === name) {
                total++;
            }
        }
    }
    return total;
  }
  
}
